import {
    thisMonthDateRefiner,
    thisWeekDateRefiner,
    selectRangeDateRefiner,
    lastWeekDateRefiner,
} from './getTextLabelForOption.locstring.json';
import loc from 'owa-localize';
import { DateRangeOption } from '../schema/DateRangeOption';
import { assertNever } from 'owa-assert';

export function getTextLabelForOption(dateRangeOption: DateRangeOption): string {
    switch (dateRangeOption) {
        case DateRangeOption.Month:
            return loc(thisMonthDateRefiner);
        case DateRangeOption.Week:
            return loc(thisWeekDateRefiner);
        case DateRangeOption.CustomDateRange:
            return loc(selectRangeDateRefiner);
        case DateRangeOption.LastWeek:
            return loc(lastWeekDateRefiner);
        default:
            return assertNever(dateRangeOption);
    }
}
